import { defineComponent } from 'vue';
import __vue_component__ from '../../cards/BasicCard/BasicCard.vue.js';

var script = defineComponent({
    name: 'TubeLabelingExample',
    components: {
        BasicCard: __vue_component__,
    },
    props: {
        patientData: {
            type: Object,
            required: true,
        },
        warningCardStyle: {
            type: String,
            default: 'white',
        },
        hideLabRejectWarning: Boolean,
    },
});

export { script as default };
